import { Pipe, PipeTransform} from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'localeDateFormat',
  standalone: true,
})
export class LocaleDateFormatPipe implements PipeTransform {

  public transform(value: string): string {
    return value ? dayjs(value).format('L') : null;
  }
}
